import { Component, OnInit } from '@angular/core';
import { ModalUsuarioAdminService } from './modal-usuario-admin.service';
import { UserService } from '../../services/services.index';

import * as _swal from 'sweetalert';
import { SweetAlert } from 'sweetalert/typings/core';
const swal: SweetAlert = _swal as any;

@Component({
  selector: 'app-modal-usuario-admin',
  templateUrl: './modal-usuario-admin.component.html',
  styles: []
})
export class ModalUsuarioAdminComponent implements OnInit {

  constructor(public _modalUsuarioAdminService: ModalUsuarioAdminService,
    public _userService: UserService) { }

  ngOnInit() {
  }

  guardarUsuarioAdmin( form: any ) {
    this._userService.guardarUsuarioAdmin(this._modalUsuarioAdminService.user).subscribe((resp: any) => {
      this._modalUsuarioAdminService.hideModal();
      swal('Usuario Guardado', 'El usuario ha sido actualizada correctamente.', 'success');
      this._modalUsuarioAdminService.notification.emit(resp);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal-usuario-admin/modal-usuario-admin.component.ts